import { buildPostUrl, canDeleteAllImagesFromPosts } from '../../../../utils';
import { TPostState } from '../../../../types/post';
import { EStatus, EType } from '../../../../repositories/journal/entities/journal/JournalAttributesSchema';
import { IApplicationContext } from '../../../../types/applicationContext';

/** Возвращает набор seo-параметров из поста */
export const getPostMeta = (post: TPostState, context: IApplicationContext) => {
  if (!('id' in post)) {
    return;
  }

  const {
    id,
    attributes: { type, slug, seoTitle, seoDescription, seoKeywords, image, noIndex, status, datePublish, updatedAt },
  } = post;

  return {
    title: seoTitle || '',
    description: seoDescription || '',
    keywords: seoKeywords || '',
    url: `https://www.cian.ru${buildPostUrl({ type, slug, id })}`,
    image: image || '',
    noIndex: Boolean(noIndex) || ([EType.Blogs, EType.Questions].includes(type) && status !== EStatus.Checked),
    noImageIndex: canDeleteAllImagesFromPosts(new Date(datePublish), context.custom.deleteAllImagesFromPostsSettings),
    datePublished: datePublish,
    dateModified: updatedAt,
  };
};
